export default [
  {
    path: '/access-control',
    name: 'access-control',
    component: () => import('@/views/theme/extensions/acl/AccessControl.vue'),
    meta: {
      resource: 'ACL',
      action: 'read',
    },
  },
]
